import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {Router} from '@angular/router';
import {TeamCompanyUsersService} from '../../services/teamcompanyusers/teamcompanyusers.service';

interface TeamCompaniesLink {
  title: string;
  link: string;
}

const ALL_LINKS: TeamCompaniesLink[] = [
  { title: 'Companies', link: '/products/companies'},
  { title: 'Permissions', link: '/products/permissions'},
  { title: 'Subscriptions', link: '/products/subscriptions'},
];

const TEAM_AGENT_LINKS: TeamCompaniesLink[] = [
  { title: 'Companies', link: '/products/companies'},
];

@Component({
    selector: 'app-team-companies',
    templateUrl: './team-companies.component.html',
    styleUrls: ['./team-companies.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TeamCompaniesComponent implements OnInit {

  public links: TeamCompaniesLink[] = [];

  public activeLink?: TeamCompaniesLink;

  constructor(
      private router: Router,
      private teamCompanyUsersService: TeamCompanyUsersService,
  ) { }

  async ngOnInit(): Promise<void> {
    const roles = await this.teamCompanyUsersService.getManagers();
    this.links = this.hasOnlyTeamAgentRoles(roles) ? TEAM_AGENT_LINKS : ALL_LINKS;

    const parsedUrl = this.router.parseUrl(this.router.url);
    const urlSegments = parsedUrl.root.children.primary.segments;
    urlSegments.length = 2;
    const currentLink = parsedUrl.toString();
    this.activeLink = this.links.find(link => link.link === currentLink);

    if (!this.activeLink) {
      this.gotoTab(this.links[0]);
    }

  }

  gotoTab(link: TeamCompaniesLink): void {
    this.activeLink = link;
    this.router.navigate([link.link]);
  }

  private hasOnlyTeamAgentRoles(result: any): boolean {
    const roles = result?.plain?.() || result || [];
    return Array.isArray(roles)
      && roles.length > 0
      && roles.every((role: any) => role?.role === 'teamagent');
  }

}
